// extracted by mini-css-extract-plugin
module.exports = {"Component":"AppButton_Component__2NcUd"};